import {
  Route,
  Routes,
  useHistoryCustomBack,
  usePanelHistoryTop,
  useSectionHistoryTop,
} from 'weblite-router'
import { goBackInProfilePanel } from '$logic/router'
import { AddContact } from '$comp/_app/components/leftPanel/components/add-contact/add-contact'
import { BlockedUsers } from '$comp/_app/components/leftPanel/components/blocked-users'
import { BlockUser } from '$comp/_app/components/leftPanel/components/block-user'
import { EditBio } from '$comp/_app/components/leftPanel/components/edit-bio'
import { EditAccount } from '$comp/_app/components/leftPanel/components/edit-account/edit-account'
import { EditContact } from '$comp/_app/components/leftPanel/components/edit-contact'
import { EditUsername } from '$comp/_app/components/leftPanel/components/edit-username'
import { MyAccount } from '$comp/_app/components/leftPanel/components/my-account/my-account'
import { PrivacyTypeSettings } from '$comp/_app/components/leftPanel/components/privacy-type-settings/privacy-type-settings'
import { Settings } from '$comp/_app/components/leftPanel/components/settings/settings'
import { AddPrivacyExceptionUsers } from '$comp/_app/components/leftPanel/components/add-privacy-exception-users'
import { Contacts } from '$comp/_app/components/leftPanel/components/contacts'
import { PrivacyExceptionUsers } from '$comp/_app/components/leftPanel/components/privacy-exception-users'
import { ActiveSessions } from '$comp/_app/components/leftPanel/components/active-sessions'
import { Invite } from '$comp/_app/components/leftPanel/components/invite-friends'
import { InviteViaPhone } from '$comp/_app/components/leftPanel/components/invite-via-phone/invite-via-phone'
import { InviteFromContacts } from '$comp/_app/components/leftPanel/components/invite-from-contacts'
import { ContactUs } from '$comp/_app/components/leftPanel/components/contact-us'
import { VisibilityHandler } from './components/visibility-handler'
import { useSetNativeColors } from '$logic/native-colors'
import { PrivacyPolicy } from '$comp/_app/components/leftPanel/components/privacy-policy/privacy-policy'
import { FAQ } from '$comp/_app/components/leftPanel/components/faq'
import { Palette } from '$setup/material-theme'
import { PremiumFeaturesIntroduction } from '$comp/_app/components/leftPanel/components/premium-features-introduction'
import { PremiumFeaturesRequestForm } from '$comp/_app/components/leftPanel/components/premium-features-request-form/premium-features-request-form'
import { DeleteAccount } from '$comp/_app/components/leftPanel/components/delete-account/delete-account'

// NOTE: Do NOT change order!
export const OTHER_PAGES = {
  MY_ACCOUNT: MyAccount,
  PREMIUM_FEATURES_INTRODUCTION: PremiumFeaturesIntroduction,
  PREMIUM_FEATURES_REQUEST_FORM: PremiumFeaturesRequestForm,
  EDIT_ACCOUNT: EditAccount,
  DELETE_ACCOUNT: DeleteAccount,
  EDIT_BIO: EditBio,
  EDIT_USERNAME: EditUsername,

  CONTACTS: Contacts,
  ADD_CONTACT: AddContact,
  EDIT_CONTACT: EditContact,

  INVITE_FRIENDS: Invite,
  INVITE_VIA_PHONE: InviteViaPhone,
  INVITE_FROM_CONTACTS: InviteFromContacts,

  SETTINGS: Settings,
  ACTIVE_DEVICES: ActiveSessions,
  BLOCKED_USERS: BlockedUsers,
  BLOCK_USER: BlockUser,

  PRIVACY_TYPE_SETTINGS: PrivacyTypeSettings,
  PRIVACY_EXCEPTION_USERS: PrivacyExceptionUsers,
  ADD_PRIVACY_EXCEPTION_USERS: AddPrivacyExceptionUsers,

  CONTACT_US: ContactUs,
  PRIVACY_POLICY: PrivacyPolicy,
  FAQ: FAQ,
}

export function Profile() {
  useHistoryCustomBack(() => {
    goBackInProfilePanel()
  }, [])

  const leftSectionTop = useSectionHistoryTop('left')
  const panelTop = usePanelHistoryTop('profile')
  const [topPage] = panelTop?.location?.split('/').slice(-1) ?? []

  const accountPageIsTop =
    leftSectionTop === 'profile' &&
    (topPage === 'MY_ACCOUNT' || topPage === 'EDIT_ACCOUNT')

  useSetNativeColors(
    () => ({
      statusBar: Palette.neutral100,
    }),
    [],
    accountPageIsTop,
  )

  if (!panelTop?.location) return null
  const { state } = panelTop

  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <div style={{ overflow: 'hidden', height: '100%' }}>
        <Routes>
          <Route
            name="profile"
            routeTransitions={{
              name: 'pushSlide',
              slideStyles: { backgroundColor: '#F6F6F6' },
            }}
          >
            {Object.keys(OTHER_PAGES).map(page => {
              const Component = OTHER_PAGES[page as keyof typeof OTHER_PAGES]
              // @ts-ignore
              return <Route name={page} element={<Component {...state} />} />
            })}
          </Route>
        </Routes>
      </div>
    </VisibilityHandler>
  )
}
